import AlsoCompare from "@components/ComparisonPage/AlsoCompare";
import ComparisonTable from "@components/ComparisonPage/ComparisonTable";
import H1Text from "@components/ComparisonPage/H1Text";
import ProsConsBox from "@components/ComparisonPage/ProsConsBox";

import GallaboxSpotlightFeatures from "@components/ComparisonPage/GallaboxSpotlightFeatures";
import GallaboxVideo from "@components/GallaboxVideo";
import NewLayout from "@components/new-ui/Layout";
import { imageCard } from "@utils/comparison";
import { FC } from "react";

import HeroButton from "@components/HeroButton";

const comparative = [
    {
        title: "Pricing factors",
        tocomp: "Based on location, traffic, country regulations and more.",
        gallabox: "Pick from three different subscription plans that best suits your team.",
    },
    { title: "Green tick verification", tocomp: "no.png", gallabox: "Free green-tick application" },
    { title: "Chatbot Flows", tocomp: "Basic Shopping Bot", gallabox: "Advanced Chatbot with Bot Actions " },
    { title: "Chatbot Templates", tocomp: "Limited to Use Cases", gallabox: "Covers all sector & industry workflows" },
    { title: "Contacts Managements", tocomp: "yes.png", gallabox: "yes.png" },
    { title: "Integrations", tocomp: "gallabox-integrations.png", gallabox: "gallabox-integrations.png" },
    { title: "Broadcast Scheduling", tocomp: "yes.png", gallabox: "yes.png" },
    { title: "WhatsApp Shop", tocomp: "yes.png", gallabox: "yes.png" },
    { title: "Canned Responses", tocomp: "yes.png", gallabox: "yes.png" },
    { title: "Follow-up Reminders for Re-engagement", tocomp: "no.png", gallabox: "yes.png" },
    { title: "Free Trial", tocomp: "yes.png", gallabox: "yes.png" },
    { title: "Support", tocomp: "Email + WhatsApp", gallabox: "Call + Email + WhatsApp" },
];
const prosCons = {
    pros: ["Omnichannel support tool.", "Comprehensive guide to building communication workflows", "Automated chatbot flows to increase team productivity."],
    cons: [
        "Being an omnichannel service provider, Infobip's features do not specialise in WhatsApp Business Solutions.",
        "Can be costly as they create a subscription plan based on many factors including traffic, country restrictions, location, etc.",
        "Infobip’s team inbox is best suited to manage all types of messaging and communication channels, which is complex and hard to use.",
    ],
};

const keyPoints = [
    "Shop on WhatsApp with Gallabox’s WhatsApp Catalogues",
    "Easy to Build No-code Chatbot with Chatbot Templates",
    "User-Friendly Team Dashboard",
    "Re-Engagement Tools like: Bulk Broadcasting, Segmented Broadcasting, Follow-up Reminders, Assignment Rules, and more",
    "Access your Gallabox account from Anywhere with Our Mobile Application.",
];

const InfobipComaprison: FC = () => {
    return (
        <NewLayout
            title="Gallabox - Best Alternative to Infobip "
            description="Don't limit yourself to WhatsApp Business! With Gallabox's WhatsApp Business Solution you can leverage WhatsApp chatbot, Team inbox, WhatsApp Broadcast Integrations with E-commerce store, Zoho, Razorpay and many more. Learn why Gallabox is the best alternative to Infobip"
            canonical="https://gallabox.com/infobip-alternative"
        >
            <header className="comparisons-header mob-pad text-center py-20">
                <div className="flex justify-center items-center mb-5">
                    <div className="">
                        <img src="comparison-page/gallabox-logo.png" alt="gallabox logo" />
                    </div>{" "}
                    <span className="mx-6 text-lg font-bold">vs</span>{" "}
                    <div className="">
                        <img src="comparison-page/infobip-logo.png" alt="infobip logo" />
                    </div>
                </div>
                <H1Text content={"Infobip WhatsApp Business API Alternative"} />

                <div className="mt-3 lg:pt-6 text-center flex lg:gap-6 gap-3 max-w-6xl mx-auto justify-center">
                    <HeroButton buttontext="Sign up for Free" />
                </div>
            </header>
            <section className="text-center my-20 mob-pad">
                <div>
                    <h2 className=" text-3xl text-bold mb-8" style={{ color: "#1A202C", fontSize: "32px" }}>
                        Gallabox - Your All In One WhatsApp Business Tool{" "}
                    </h2>
                    <p className="text-lg text-gray-600 max-w-5xl mx-auto">
                        Gallabox is a one-stop customer support WhatsApp Business tool that empowers businesses to engage quicker and better with their customers. The multi-agent
                        team inbox supports as many agents as required with unlimited contact management and an easy-to-use no-code chatbot builder.
                    </p>
                </div>
            </section>
            <section className="text-center mob-pad md:px-20">
                <div>
                    <h2 className=" text-3xl text-bold mb-8" style={{ color: "#1A202C", fontSize: "32px" }}>
                        Gallabox’s Latest Launch: WhatsApp Chatbot Templates Makes Building A Bot As Easy As 1,2,3{" "}
                    </h2>
                    <div className="flex flex-wrap justify-center gap-3">
                        <div className="bg-white inline-block rounded-md relative">
                            <div className="p-2">
                                <img src="comparison-page/building-bot-s1.png" alt="Simply select the template of your choice" />
                            </div>
                            <p className="mb-8 mt-7 text-lg text-gray-600 " style={{ width: "100%", maxWidth: "295px" }}>
                                Simply select the template of your choice{" "}
                            </p>
                        </div>
                        <div className="bg-white inline-block rounded-md relative">
                            <div className="p-2">
                                <img src="comparison-page/building-bot-s2.png" alt="Customise it to your brand" />
                            </div>
                            <p className="mb-8 mt-7 text-lg text-gray-600 " style={{ width: "100%", maxWidth: "295px" }}>
                                Customise it to your brand{" "}
                            </p>
                        </div>
                        <div className="bg-white inline-block rounded-md relative">
                            <div className="p-2">
                                <img src="comparison-page/building-bot-s3.png" alt="Deploy your bot" />
                            </div>
                            <p className="mb-8 mt-7 text-lg text-gray-600 " style={{ width: "100%", maxWidth: "295px" }}>
                                Deploy your bot{" "}
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="text-center mob-pad my-20">
                <ComparisonTable comparative={comparative} compareWith={"infobip"} />
            </section>
            <section className="mt-12 mob-pad">
                <ProsConsBox prosCons={prosCons} compareWith={"Infobip"} />
            </section>
            <section className="mob-pad">
                <GallaboxSpotlightFeatures
                    mainTitle="Why Gallabox?"
                    description="Gallabox’s shared team inbox unleashes the superpower of WhatsApp Business APIs providing users with the best tools to increase their support, sales, marketing, and team efforts. If you are wondering why Gallabox is the WhatsApp solution you should choose alternatively to Infobip, here are some of our best offerings:"
                    imageCard={imageCard}
                    keyPoints={keyPoints}
                />
            </section>
            <section className="bg-black pb-12 mob-pad">
                <AlsoCompare toComp={"infobip"} indexNo={4} />
            </section>
            <section className="relative bg-rhino mob-pad">
                <GallaboxVideo />
            </section>
        </NewLayout>
    );
};

export default InfobipComaprison;
